import { Dispatch } from "redux";
import { All } from "../interfaces";

import * as actions from "../common/actions";
import { connect } from "react-redux";
import BankFindDetailsMenu from "../components/BankFind/BankFindDetailsMenu";
import { searchPush, updateUi } from "../common/actions";
export function mapStateToProps({ appState }: All) {
  return {
    appState: appState.bankFind,
  };
}
export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateUi: (uiField: string, uiValue: string) => {
      dispatch(updateUi(uiField, uiValue));
      dispatch(searchPush());
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BankFindDetailsMenu);
